// extracted by mini-css-extract-plugin
export default {"container":"last-update-widget_container__sUG4h"};